<app-header-helena class="request-banner" bannerImage="just-seeds.webp"></app-header-helena>

<h1 >Seed Treatment Design Request</h1>
<p >This facility is primarily intended for our seed companies partners</p>
<p>
  Many of the nutritional and biostimulant products that Helena supplies
  can be adapted to be used as a seed coating. Our chemists have much experience
  in designing seed treatments and evaluating performance.
</p>
<p>
  We offer a sepecial service to representatives of seed companies, and growers
  who understake large-scale seed treatment. You may specify a desired nutrient
  application, and give us details of the seeds and other products in the
  potential coating. Our chemists will then conduct an experimental trial which
  will confirm an optimal formulation to achieve desired nutritional
  performance, chemical compatibility and ease of manufacture/application.
</p>
<p >
  In some cases, seed companies will want to apply multiple products within a
  single seed treatment. Therefore our chemnists will analyse the entire
  treament mix to ensure that there are no adverse chemical interactions,
  including ingredients that may be supplied by a third party.
</p>

<p >
  All such product development work is naturally commercially sensitive, and it
  is normal to consent to a non-disclosure agreement so that our partners can be
  assured their product development activitries are kept private
</p>
<div class="alert alert-warning">
  <p>
    <strong >Reasonable Request:</strong>
  </p>
  <p >
    We do not charge any fees for the tankmix laboratory analysis. The service
    is free of charge. We expect that at least one Helena product is included in
    the mix; if no Helena product is included, your request may be rejected.
  </p>
</div>

<form [formGroup]="seedCoatingRequestForm">
  
  <div class="sideBySide">
    
    <div >
      <div class="form-group">
        <label for="nameTextBox"  >Name</label>
        <input
          type="text"
          id="nameTextBox"
          name="nameTextBox"
           formControlName="name"
          autocomplete="family-name"
        />
        <div *ngIf="name.errors?.['required'] && name.touched" class="text-danger"> 
          Name is required
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="emailTextBox"  >Email</label>
        <input
          type="email"
          id="emailTextBox"
          name="emailTextBox"
           formControlName="email"
        />
        <div *ngIf="email.errors?.['required'] && email.touched" class="text-danger"> 
          *
        </div> 
        <div *ngIf="email.errors?.['email'] && email.touched" class="text-danger"> 
          *
        </div> 
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="companyTextBox" >Company</label>
        <input
          type="text"
          id="companyTextBox"
          name="companyTextBox"
          formControlNatankmixRequestFormme="company"
        />
      
        <small class="form-text textmuted"></small>
      </div>
    </div>
  
    <div >
      
      <div class="form-group">
        <label for="requestDateTextBox"  >Request Date</label>
        <input
          type="date"
          id="requestDateTextBox"
          name="requestDateTextBox"
           
          formControlName="requestDate"
        />
        <div *ngIf="requestDate.errors?.['required'] && requestDate.touched" class="text-danger"> 
          Request Date is required
        </div> 
        <small class="form-text textmuted"></small>
      </div>
     
      <div class="form-group">
        <label for="countryDropDown"  >Country</label>
        <select
          id="countryDropDown"
          name="countryDropDown"
           formControlName="country"
        >
        <option [value]="" [ngValue]="null" disabled>--</option>
        <option
            *ngFor="let choice of countryChoices"
            [value]="choice.code + ' - ' + choice.name"
          >
            {{ choice.name }}
          </option>
        </select>
      </div>
       
      <div class="form-group">
        <label for="requestDateTextBox"  >Non Disclosure Agreement Reference</label
        >
        <input type="text" id="ndaRef"  name="ndaRef" formControlName="ndaRef" />
       
      </div>

    

     </div>
    
  </div>
   
      <div class="form-group">
        <label for="commentsTextArea"  >Comments</label>
        <textarea
          type="text"
          id="commentsTextArea"
          name="commentsTextArea"
           rows="3"
          formControlName="comments"
        ></textarea>
       
      </div>
   
<div class="form-group">
  <label for="seedName"  >Seed Crop</label>
      <input   type="text"  id="seedName"  name="seedName"   formControlName="seedName"
      />
   
</div>

<div class="request-ingredient-table" formArrayName="ingredients">
  <div class="header">
    <span>Order of Addition</span>
    <span>Product or Agrochemical</span>
    <span  >Desired Amount</span>
    <span  >Units</span>
    <span></span>
  </div>
  <ng-container
  *ngFor="let ingredient of ingredients.controls; let i = index"
>
  <div class='ingredientRow'[formGroup]="ingredient" >
    <span  class="order-of-addition" >
      {{ i + 1 }}

    
    </span>
    <span>
      <input
        type="text"
        name="ingredientname"
        formControlName="name" placeholder="Product or Agrochemical"
       
      />
    </span>

    <span>
      <input
        type="number"
        name="applicationRate"
        min="0"
     
        formControlName="applicationRate"
        placeholder="Desired Amount"
        
      />
    </span>
    <span>
      <select
      
        formControlName="applicationUnit"
        name="applicationUnit"
      >
        <option value="">--</option>
      <option *ngFor="let choice of applicationUnitChoices">
          {{ choice }}
        </option>
      </select>
    </span>
    <span>
      <button
        *ngIf="i > 0"
        class="btn-danger"
        (click)="deleteProduct(i)"  
      >
        Delete
      </button>
    </span>
  </div>
</ng-container>
</div>


  <table class="table-yara">
    
   
    <tbody>
    
      
     
  
    </tbody>
  </table>

  <p class="aside"  >
    Please Note: Instead of a specifying a Product, you can also either
    specify a list of wanted nutrients, and our micronutrient agronomists will
    select appriopriate product(s) for you
  </p>
  <button id="addIngredient" class="btn" (click)="addProduct()"  >
    Add Ingredient
  </button>
  
</form>
<br />
<app-empty-ingredient *ngIf="invalidIngredients"></app-empty-ingredient>
<button    id="submit" class="btn-success" (click)="submitRequest()"  
[disabled]=seedCoatingRequestForm.invalid>Submit</button>

<div id="formedEmail" class="never-displayed">
  <h1  >Details</h1>
  <table>
    <tr>
      <th  >Name</th>
      <td>{{ formValues.name }}</td>
    </tr>
    <tr>
      <th  >Email</th>
      <td>{{ formValues.email }}</td>
    </tr>
    <tr>
      <th  >Company</th>
      <td>{{ formValues.company }}</td>
    </tr>
    <tr>
      <th  >Request Date</th>
      <td>{{ formValues.requestDate }}</td>
    </tr>
    <tr>
      <th  >Country</th>
      <td>{{ formValues.country }}</td>
    </tr>
    <tr>
      <th  >Water Rate</th>
      <td>{{ formValues.waterRate }}</td>
    </tr>
    <tr>
      <th  >Comments</th>
      <td>{{ formValues.comments }}</td>
    </tr>
    <tr></tr>
  </table>

  <h2  >Composition</h2>

  <table class="">
    <thead></thead>
    <tr>
      <th  >Order Of Addition</th>
      <th>Product or agrochemical</th>
      <th  >Application Rate</th>
      <th  >Units</th>
    </tr>
    <tbody>
    </tbody>
  </table>
</div>

